<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  activities: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  limit: { type: Number, default: 6 },
});

const emit = defineEmits(['open', 'react']);
const { t } = useI18n();
</script>

<template>
  <section
    class="rounded-lais border border-lais-border-soft bg-white shadow-lais-card"
    :aria-busy="loading ? 'true' : 'false'"
  >
    <header
      class="flex items-center justify-between gap-3 border-b border-lais-border-soft px-4 py-3"
    >
      <h2 class="text-sm font-bold text-lais-text">
        {{ t('GAMIFICATION.ACTIVITY.TITLE') }}
      </h2>
      <button
        type="button"
        class="text-xs font-semibold text-lais-primary hover:text-lais-primary-600"
        @click="emit('open')"
      >
        {{ t('GAMIFICATION.COMMON.VIEW_ALL') }}
      </button>
    </header>
    <div v-if="loading" class="space-y-3 p-4">
      <div v-for="index in 3" :key="index" class="flex animate-pulse gap-3">
        <span class="size-8 rounded-full bg-lais-bg-soft" />
        <span class="h-8 flex-1 rounded bg-lais-bg-soft" />
      </div>
    </div>
    <div
      v-else-if="!activities.length"
      class="px-4 py-8 text-center text-sm text-lais-text-muted"
    >
      {{ t('GAMIFICATION.ACTIVITY.EMPTY') }}
    </div>
    <ul v-else class="divide-y divide-lais-border-soft">
      <li
        v-for="activity in activities.slice(0, limit)"
        :key="activity.id"
        class="flex gap-3 px-4 py-3"
      >
        <span
          class="grid size-8 shrink-0 place-items-center rounded-full bg-lais-primary-50 text-lais-primary"
          aria-hidden="true"
        >
          <span class="i-lucide-sparkles size-4" />
        </span>
        <div class="min-w-0 flex-1">
          <p class="text-xs leading-relaxed text-lais-text">
            <span class="font-semibold">{{
              activity.user?.name || t('GAMIFICATION.COMMON.SOMEONE')
            }}</span>
            {{
              activity.title ||
              activity.body ||
              t('GAMIFICATION.ACTIVITY.DEFAULT')
            }}
          </p>
          <div
            class="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-lais-text-muted"
          >
            <time v-if="activity.occurred_at" :datetime="activity.occurred_at">
              {{ activity.occurred_at }}
            </time>
            <span
              v-if="activity.metadata?.points"
              class="font-semibold text-lais-primary"
            >
              {{
                t('GAMIFICATION.BAR.MISSION_POINTS', {
                  points: activity.metadata.points,
                  unit: t('GAMIFICATION.BAR.POINTS_SHORT'),
                })
              }}
            </span>
            <button
              type="button"
              class="ml-auto font-medium hover:text-lais-primary"
              @click="emit('react', activity)"
            >
              {{ t('GAMIFICATION.ACTIVITY.CELEBRATE') }}
            </button>
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>
